import { useEffect } from 'react';
import { Button } from '@material-ui/core';
import { IconStar } from '@tabler/icons';
import clsx from 'clsx';

import { useDialog } from '#root/hooks';
import { RatingDialog } from '#root/components';
import { GuveryPaper } from '#root/ui-components/cards';
import styles from './rating.module.scss';

interface RatingProps {
  isOpenDialog?: boolean;
  deal?: any;
  dealIda?: any;
  isReady?: boolean;
  handleLoading?: () => void;
  createMessage?: any;
}

const Rating = (props: RatingProps) => {
  const {
    isOpenDialog = false,
    deal,
    dealIda,
    isReady,
    handleLoading,
    createMessage,
  } = props;
  const ratingDialog = useDialog();
  const ratingToTraveler = deal?.rating_to_traveler;

  useEffect(() => {
    // Solo abrir el diálogo si no ha calificado aún
    if (isOpenDialog && !ratingToTraveler?.score) {
      ratingDialog.openDialog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenDialog, ratingToTraveler?.score]);

  return (
    <GuveryPaper
      disableHover
      disableBorder={ratingToTraveler?.score ? true : false}
      disableElevation>
      {ratingToTraveler?.score && (
        <p className={clsx(styles.root, styles.rating)}>
          <span className={styles.text}>Calificaste al viajero con</span>
          <span className={styles.score}>
            {ratingToTraveler?.score} <IconStar />
          </span>
        </p>
      )}
      {!ratingToTraveler?.score && (
        <div className={styles.root}>
          <p className={styles.qualify}>
            <span className={styles.text}>
              {!isReady ? (
                <span>
                  Ayúdanos a mantener una comunidad confiable. Califica a tu viajero de forma
                  anónima.
                </span>
              ) : (
                <span>Confirma la recepción y/o califica al viajero.</span>
              )}
            </span>
          </p>
          <Button
            fullWidth
            disableElevation
            onClick={ratingDialog.openDialog}
            variant="outlined"
            color="primary"
            style={{ marginTop: '16px' }}
            startIcon={<IconStar />}>
            Calificar
          </Button>
        </div>
      )}
      <RatingDialog
        id={dealIda}
        ratingId={ratingToTraveler?.id}
        open={ratingDialog.open}
        onClose={ratingDialog.closeDialog}
        ratingType="shopper"
        title="Estas calificando a tu viajero"
        date1={deal?.fecentcom}
        date2={deal?.fecentvia}
        hint="Esta es una calificación anónima. El viajero no será notificado ni podrá saber su calificación."
        userData={deal?.offer?.traveler}
        handleLoading={handleLoading}
        createMessage={createMessage}
        confirmText={isReady && 'Confirmar recepción y calificar'}
      />
    </GuveryPaper>
  );
};

export default Rating;
